import { persist } from "zustand/middleware";

import { AuthenStoreType, Authentication } from "../types/authen";

const initialStore: AuthenStoreType = {
  user: null,
  clearAuthState: () => {},
  setAuthState: () => {},
};

const authStore = persist(
  (set) => ({
    user: initialStore.user,
    setAuthState: (data: Authentication) => set(() => ({ user: data })),
    clearAuthState: () => set({ user: initialStore.user }),
  }),
  {
    name: "user",
    version: 0.1,
  },
);

export { authStore };
